import React from 'react'
import Header from '../components/homePage/Header'
import Experience from '../components/homePage/Experience'
import PortfolioCards from '../components/homePage/PortfolioCards'

export default function Home() {
  return (
    <div className='container mx-auto justify-center my-24'>
        <Header/>
        <Experience/>
        <PortfolioCards/>
    </div>
  )
}
